
import {map} from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { Observable ,  Subject } from "rxjs";
import "rxjs/Rx";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Baseservice } from './baseservice'

import { AuthenticationService } from './authentication.service';

@Injectable()
export class ApplicationService extends Baseservice {
  private activeTab = new Subject<number>();

  //keeping track of changes
  public dataControlTrackChanges: any = null;
  public motivationChanged: boolean = false;
  public documentsChanged: boolean = false;
  public vehicleAdded: boolean = false;

  public vehicleLoadCount: number = 0;
  public vehiclesControlTrackChanges: any = [];

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super("application", http, authentication);
  }

  get() {
    return this.getApplication(this.url + "/application");
  }

  getById(id: any) {
    return this.getApplication(this.url + "/find/" + id);
  }
  getAllApp() {
    return this.http.get(this.url + "/find-all");
  }//permit-apps
  getAllAppPermits() {
    return this.http.get(this.url + "/permit-apps");
  }
  postAllAppPermits(data) {
    return this.http.post(this.url + "/permit-apps", data);
  }
  getApplication(url: string) {
    return this.getRequest(url).pipe(map(response => response));
  }

  postApplication(object: any) {
    let body = object;    
    console.log(this.url);
    return this.http.post(this.url, body);
  }

  putApplication(object) {
    let body = object;
    return this.http.put(this.url, body);
  }
  putApplicationDuplicate(object) {
    let body = object;
    return this.http.put(this.url + "/duplicate", body);
  }
  setTab(num) {
    this.activeTab.next(num);
  }
  getTab(): Observable<number> {
    return this.activeTab.asObservable();
  }
  deleteApplication(id) {
    //alert(this.url);
    return this.http.delete(this.url + '/' + id);
  }

  searchApplications(keyword: any, PageNum: number, PageSize: number, isDef: boolean, sort: number, direction: boolean) {
    return this.http.post(`${this.url}/search/${isDef}/${PageNum}/${PageSize}/${sort}/${direction}`, keyword);
  }

  
  getApplicationByAppId(appId :number) {
    return this.http.get(`${this.url}/getApplicationByAppId/${appId}`);
  }

  createInvoice(object) {
    let body = object;
    return this.http.post(this.url + "/invoice", body);
  }
  UnsubmitApp(id, feeType) {
    return this.getRequest(`${this.url}/unsubmit/${id}/${feeType}`);
  }
}

